<template>
  <div :class="['export_interest_image_wrapper', themeKey]">
    <template v-for="name in ['export_interest_image_main', 'export_interest_image_clone']">
      <div
        :key="name"
        :class="name"
        :style="name === 'export_interest_image_main' ? scaleStyle : {}"
      >
        <div class="export_interest_image" @click="$emit('previewAllImages')">
          <div class="eii_banner">
            <img v-if="themeStyle.config.bannerImage" :src="themeStyle.config.bannerImage">
            <header
              :style="{
                height: `${themeStyle.config.bannerHeight ? 40 / themeStyle.config.bannerHeight * 100 : 17}%`
              }"
            >
              {{ personData.main.name }}
            </header>
          </div>
          <div class="eii_body">
            <div v-if="personData" class="eii_product_info">
              <dl>
                <dt>{{ title }}</dt>
                <template v-if="productInterestInfoList && productInterestInfoList.length">
                  <dd v-for="item in productInterestInfoList">
                    <label v-html="item.label" />
                    <span>{{ item.name }}</span>
                  </dd>
                </template>
              </dl>
            </div>
            <InterestTableWithRemark
              v-if="tableData"
              scene="export"
              :cur-product-interest-data="interestData.curProductInterestData"
              :table-data="tableData"
              :form-data="interestData.curProductFormData"
              :interest-detail-with-remark="interestData.interestDetailWithRemark"
              :params="{
                insuredAge: personData.insuredInfo.age,
                period: curProductPeriod
              }"
              class="interest_table2024__export"
            />
            <div v-if="isShowBusinessCard" class="eii_card_info">
              <div class="left">
                <img v-if="cardInfo.photo" :src="cardInfo.photo" alt="photo">
                <div class="desc">
                  <p>{{ cardInfo.name }}</p>
                  <p>{{ cardInfo.telephone }}</p>
                </div>
              </div>
              <div class="right">
                <img v-if="resultUrlQRCodeImage" :src="resultUrlQRCodeImage" alt="">
                <div class="desc">
                  <p>请扫码查看详细内容</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <span
      v-if="isIos"
      class="export_interest_rerender"
      @click.stop="onClickReRenderImage"
    >
      <i class="iconfont icon-refresh" />
      重新生成图片
    </span>
  </div>
</template>
<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import QS from 'qs'
import { get as _get, cloneDeep } from 'lodash'
import domToImage from 'dom-to-image'
import QRCode from 'qrcode'
import { Picker } from 'bxs-ui-vue'

import { URL_PARAM } from '@/utils/variables.js'
import { formatCalculateData } from 'common/js/format'
import { normalizeKeys } from 'base/config'
import { MODEN_THEMES as THEME_OPTIONS } from '@/pages/planbkTemplatev2/components/banner/constant.js'
import InterestTableWithRemark from '@/pages/planbkTemplatev2/components/interestDemo/components/interest-table.vue'

Vue.use(Picker)
export default {
  components: {
    InterestTableWithRemark
  },
  props: {
    scene: Number,
    resultData: {
      type: Object,
      default: () => ({})
    },
    themeSettings: {
      type: Object,
      default: () => ({})
    },
    isShowBusinessCard: {
      type: Boolean,
      default: true
    },
    cardImageData: String,
  },
  data () {
    return {
      isIos: appBridge.isIos(),
      resultUrlQRCodeImage: null,
      scaleStyle: null,
      cacheImageDataUrl: {}
    }
  },
  computed: {
    ...mapState({
      interestData: 'interestData'
    }),
    themeKey () {
      return _get(this, 'themeSettings.previewTheme') || ''
    },
    dataURLName () {
      return `${this.themeKey}_${this.isShowBusinessCard ? 'card' : 'nocard'}`
    },
    title () {
      const _remarkTitle = _get(this, 'interestData.interestDetailWithRemark.remarkTitle') || ''

      const age = _get(this, 'personData.insuredInfo.age')
      const sex = _get(this, 'personData.insuredInfo.sex')
      const baofDesc = _get(this, 'personData.main.baofDesc')
      const pPeriodDesc = _get(this, 'personData.main.pPeriodDesc')
      const _title = `${age}岁${sex === 1 ? '男' : '女'}性 年交${baofDesc} ${pPeriodDesc === '趸交' ? pPeriodDesc : '交' + pPeriodDesc}`
      return _remarkTitle || _title
    },
    themeStyle () {
      const option = THEME_OPTIONS.find(o => o.key === this.themeKey)
      return option || THEME_OPTIONS[0]
    },
    personData () {
      const { personData } = formatCalculateData(this.resultData.resultData, normalizeKeys)
      return personData
    },
    cardInfo () {
      return _get(this.resultData, 'card')
    },
    curProductPeriod () {
      const { curProductResultData } = this.interestData
      if (!curProductResultData) {
        return 0
      }
      const firstInsurance = curProductResultData.mulInsOrderList.find(ins => ins.key !== 'common')
      if (firstInsurance) {
        return firstInsurance.period
      }
      return 0
    },
    productInterestInfoList () {
      const { curProductFormData, interestFieldOptions } = this.interestData
      const formValues = _get(curProductFormData, 'formValues')
      if (!interestFieldOptions || !formValues) {
        return 
      }
      const objs = {
        bonus: '分&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp红',
        rate: '账户利率',
        drawData: '减保领取',
        addAndTakeData: '追加领取',
      }
      const keys = ['bonus', 'rate', 'drawData', 'addAndTakeData']
      return keys.map(k => {
        const item = interestFieldOptions.find(e => e.key === k)
        const options = item && item.options
        const option = options && options.find(o => k === 'rate' ? o.index === formValues.rateIndex : o.value === formValues[k])

        let name = ''
        if (k === 'bonus' && option) {
          name = option.description
        }
        if (k === 'rate' && option) {
          name = formValues.rateIndex === -1 ? '自定义利率' + `(${(curProductFormData.customRate * 100).toFixed(2)}%)` : option.description
        }
        if (k === 'drawData' && options && options.length) {
          name = `${objs[k]}${!formValues.drawFlag ? '前' : '后'}`
        }
        if (k === 'addAndTakeData' && options && options.length) {
          name = `${objs[k]}${!formValues.addAndTakeFlag ? '前' : '后'}`
        }
        return {
          label: objs[k],
          name
        }
      }).filter(e => e.name)
    },
    tableData () {
      const tableData = cloneDeep(_get(this.interestData, 'interestTableData'))
      return tableData || []
    }
  },
  watch: {
    isShowBusinessCard () {
      this.scaleInterestTable()
    },
    themeKey () {
      this.getUrlQRCode()
      this.scaleInterestTable()
    },
    productInterestInfoList () {
      this.cacheImageDataUrl = {}
    },
    tableData () {
      this.cacheImageDataUrl = {}
      this.scaleInterestTable()
    },
  },
  async created () {
    this.getUrlQRCode()
  },
  mounted () {
    const self = this
    self.scaleInterestTable()
    setTimeout(() => {
      self.scaleInterestTable()
    }, 1000)
  },
  methods: {
    async getUrlQRCode () {
      const { resultData, themeKey : theme } = this
      const { uuid, cardUuid } = URL_PARAM
      const resultParams = {
        uuid,
        theme,
        cardUuid: cardUuid || _get(resultData, 'card.uuid')
      }
      const resultUrl = `${location.origin}${location.pathname}?${QS.stringify(resultParams)}`
      this.resultUrlQRCodeImage = await QRCode.toDataURL(resultUrl, {
        width: 120,
        margin: 0
      })
    },
    scaleInterestTable () {
      const self = this
      const { scene } = self
      self.$nextTick(() => {
        const wrapperDom = document.querySelector('.export_interest_image_wrapper')
        if (!wrapperDom) {
          return
        }
        const parentDom = wrapperDom.parentElement
        const interestDom = wrapperDom.querySelector('.export_interest_image_main .export_interest_image')
        if (!parentDom || !interestDom) {
          return
        }
        const cloneInterestDom = wrapperDom.querySelector('.export_interest_image_clone .export_interest_image')
        const cloneEiiBodyDom = cloneInterestDom && cloneInterestDom.querySelector('.export_interest_image_clone .export_interest_image .eii_body')
        const cloneHeaderTable = cloneEiiBodyDom && cloneEiiBodyDom.querySelector('.interest_table2024__export .interest_table_main .normal_table_main .normal_header table')
        const cloneBodyTable = cloneEiiBodyDom && cloneEiiBodyDom.querySelector('.interest_table2024__export .interest_table_main .normal_table_main .table_body table')
        if (cloneEiiBodyDom) {
          const areaLimitScale = Math.min(15000000 / (cloneInterestDom.offsetWidth * cloneInterestDom.offsetHeight), 1)
          if (areaLimitScale < 1) {
            const _width = cloneInterestDom.offsetWidth * areaLimitScale
            cloneInterestDom.style.minWidth = _width  + 'px'
            cloneInterestDom.style.maxWidth = _width  + 'px'
            cloneInterestDom.style.fontSize = 39 * areaLimitScale + 'px'
            cloneEiiBodyDom.style.minWidth = _width  + 'px'
            cloneEiiBodyDom.style.maxWidth = _width  + 'px'
            if (cloneHeaderTable) {
              cloneHeaderTable.style.width = (_width * ((375 - 9) / 375) + 'px')
            }
            if (cloneBodyTable) {
              cloneBodyTable.style.width = (_width * ((375 - 9) / 375) + 'px')
            }
          }
        }
        const scaleWidth = (parentDom.offsetWidth - 24 * 2) / interestDom.offsetWidth
        self.scaleStyle = {
          transform: `scale(${scaleWidth}) translate(${24 / scaleWidth}px, ${24 / scaleWidth}px)`,
          transformOrigin: `left top`,
        }
        if ([1, 3].includes(scene)) {
          parentDom.style.alignItems = 'start'
          parentDom.style.overflowY = 'auto'
          wrapperDom.style.height = (interestDom.offsetHeight * scaleWidth + 24 * 2) + 'px'
        } else {
          parentDom.style.height = (interestDom.offsetHeight * scaleWidth + 24 * 2) + 'px'
        }
      })
    },
    async generateImage (isShowLoading = true) {
      const self = this
      const { cacheImageDataUrl, dataURLName, isIos } = self
      if (cacheImageDataUrl[dataURLName]) {
        return cacheImageDataUrl[dataURLName]
      }

      const cloneDom = document.querySelector('.export_interest_image_clone .export_interest_image')
      if (!cloneDom) {
        return
      }
      // iOS需要2次调用方法，才能保证图片正确生成
      // https://github.com/bubkoo/html-to-image/issues/52
      if (isShowLoading) {
        appBridge.showLoading()
      }
      return new Promise((resolve) => {
        setTimeout(async () => {
          if (isIos) {
            await domToImage
              .toPng(cloneDom)
              .then(() => domToImage.toPng(cloneDom))
              .then(dataURL => {
                cacheImageDataUrl[dataURLName] = dataURL
              })
              .catch(error => {
                console.error('domToImage: ', error)
                this.$toast('生成图片异常！')
              })
          } else {
            await domToImage
              .toPng(cloneDom)
              .then(dataURL => {
                cacheImageDataUrl[dataURLName] = dataURL
              })
              .catch(error => {
                console.error('domToImage: ', error)
                self.$toast('生成图片失败！')
              })
          }
          if (isShowLoading) {
            appBridge.hideLoading()
          }
          resolve(cacheImageDataUrl[dataURLName])
        }, 300)
      })
    },
    onClickReRenderImage () {
      this.cacheImageDataUrl[this.dataURLName] = null
      this.$emit('previewAllImages')
    }
  }
}
</script>
<style>
@import './index.css';
</style>
